import React, { useEffect, useMemo, useState } from 'react'
import Modal from '../commonComponents/Modal'
import ImageWithBasePath from '../components/ImageWithBasePath'
import { AdvertiserPrimaryButton } from '../commonComponents/AdvertiserPrimaryButton'
import { PreviewJobCard } from '../commonComponents/PreviewJobCard'
import { MobileNumberInput } from './MobileNumberInput'
import useTranslation from '../hooks/useTranslation'
import { appLinkSentHandler } from '../utils/functions'

export const AppLinkSendModal = ({ isOpen, onClose, jobDetails }) => {
  const translation = useTranslation()

  const [mobileNumber, setMobileNumber] = useState('')
  const [isErrorPresent, setErrorPresent] = useState(false)
  const [isSuccessModalOpen, setSuccessModal] = useState(false)
  const [loader, setLoader] = useState(false)
  const jobCreativesLength = jobDetails?.creatives?.length - 1
  const cardDetals = useMemo(
    () => ({
      logo: jobDetails?.creatives?.[jobCreativesLength]?.file || 'anonymousIcon',
      isUrl: jobDetails?.creatives?.[jobCreativesLength]?.file,
      jobRoll: jobDetails?.job_role,
      company_name: jobDetails?.translated_content?.company_name,
      title: jobDetails?.translated_content?.title,
      salary: jobDetails?.translated_content?.primary_details?.Salary,
      jobType: jobDetails?.translated_content?.primary_details?.Job_Type,
      location: jobDetails?.job_location_slug,
      experience: jobDetails?.translated_content?.primary_details?.Experience,
      jobHours: jobDetails?.job_hours,
      qualification: jobDetails?.translated_content?.primary_details?.Qualification,
      isWhatsPresent: jobDetails?.contact_preference?.['preference'] !== 0 && jobDetails?.contact_preference?.['preference'] !== 2
    }),
    [isOpen]
  )

  useEffect(() => {
    if (isOpen) {
      setMobileNumber('')
      setErrorPresent(false)
      setSuccessModal(false)
    }
  }, [isOpen])

  return (
    <Modal {...{ isOpen, onClose }}>
      {!isSuccessModalOpen && (
        <div className="rounded-[10px] bg-[white] font-noto-sans shadow-modal">
          <div className="flex h-[50px] place-content-end items-center pr-[12px]">
            <div className="relative h-[24px] w-[24px]" onClick={onClose}>
              <ImageWithBasePath src="ph_x" fill alt="close symbol" />
            </div>
          </div>
          <div className="px-[24px] pt-[24px]  sm:pr-sm  md:px-[24px]">
            <div className="flex justify-between sm:flex-col sm:items-center  md:flex-row md:items-start md:space-x-[64px]">
              <div className="w-[552px] space-y-[24px]">
                <div className="flex  flex-col  sm:items-center md:items-start">
                  <div className=" text-[32px] font-bold leading-[40px] text-[#333436]">
                    Download the Lokal app now!
                  </div>
                  <div className=" text-[24px] font-bold leading-[40px] text-[#666666]">
                    Call HR & get your dream job on Lokal app.
                  </div>
                </div>
                <div className=" text-base font-normal leading-[22px] text-[#333436]">
                  Enter the mobile number to get app link
                </div>
                <div className="mt-[16px] font-noto-sans">
                  <div className="text-sm font-normal leading-[16.31px] text-[#323232]">
                    {translation?.mobileNumber}
                  </div>
                  <MobileNumberInput
                    {...{
                      id: 'otp send',
                      onChange: (event) => {
                        setMobileNumber(event?.target?.value || '')
                      },
                      countryCode: '91',
                      autoFocus: true,
                      mobileNumber,
                      error: isErrorPresent,
                      errorMsg: '*Please enter valid mobile number',
                      disabled: false,
                      containerClassName: 'sm:mr-[32px] md:mr-[0px]'
                    }}
                  />
                </div>
                <div className="flex  pb-24 sm:justify-center md:justify-start">
                  <AdvertiserPrimaryButton
                    title={'Download app'}
                    isArrowPresent={false}
                    extraClassName="bg-secondary"
                    containerClassName="w-[313px]"
                    loading={loader}
                    onClick={async () => {
                      setLoader(true)
                      if (mobileNumber?.length != 10) setErrorPresent(true)
                      else await appLinkSentHandler(mobileNumber, setSuccessModal, setErrorPresent)
                      setLoader(false)
                    }}
                  />
                </div>
              </div>
              <PreviewJobCard
                {...{
                  cardDetals: cardDetals,
                  mobileClassName: 'h-[312px] w-[182.19px]',
                  imageName: 'app_link_sent_bg_image',
                  containerClassName: 'sm:mt-[0px]'
                }}
              />
            </div>
          </div>
        </div>
      )}
      {isSuccessModalOpen && (
        <div className="flex  w-[398px] flex-col items-center bg-white px-[16px] pt-[24px] pb-[13px]">
          <div className="relative h-[80px] w-[80px]">
            <ImageWithBasePath src="post_job_success" fill alt="success indicator" />
          </div>
          <div className="mt-sm w-[350px] text-center font-noto-sans text-[24px] font-bold leading-[32.69px] text-[#191919] md:mt-12">
            Download link sent to your phone number
          </div>
          <div className="mt-12 text-center font-noto-sans text-base leading-[22.4px] text-[#333436]">
            Download the Lokal app and Call HR for the job.
          </div>
          <AdvertiserPrimaryButton
            isArrowPresent={false}
            title={'Okay'}
            containerClassName="h-[42px] mt-[24px] sm:mt-[32px]"
            onClick={onClose}
          />
        </div>
      )}
    </Modal>
  )
}
